import { Modal, Typography } from '@arkestro/arkestro-design-system';
import useTranslation from 'next-translate/useTranslation';
import type { ID } from 'types';

const priceAgreementEditUrl = (id: ID) => `/bid_requests?tab=agreements&openEdit=${id}`;

interface InheritedBusinessUnitEditModalProps {
  agreementId: ID;
  onClose: () => void;
  open: boolean;
}

/** Confirms leaving for the agreement, where its business unit is edited, in a new tab. */
export const InheritedBusinessUnitEditModal = ({ agreementId, onClose, open }: InheritedBusinessUnitEditModalProps) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      okText={t('rfx_drawer.inherited_business_unit_edit_modal_confirm')}
      onCancel={onClose}
      onOk={() => {
        window.open(priceAgreementEditUrl(agreementId), '_blank', 'noopener,noreferrer');
        onClose();
      }}
      open={open}
      title={t('rfx_drawer.inherited_business_unit_edit_modal_title')}
    >
      <Typography.Text>{t('rfx_drawer.inherited_business_unit_edit_modal_content')}</Typography.Text>
    </Modal>
  );
};
